import { UI_ENV } from '../config/awsChimeConfig'

const Health = () => {
    return (
      <p> Running in { UI_ENV } server... </p>
    )
}

export default Health